import type { IStoreSelectedFacet } from '@generated/graphql'
import { deepObjectCopy } from 'src/utils'

export const facetChange = (
  item: IStoreSelectedFacet,
  selectedFacetsFilter: IStoreSelectedFacet[],
  setSelectedFacetsFilter: React.Dispatch<
    React.SetStateAction<IStoreSelectedFacet[]>
  >
) => {
  const facetsSelecteds: IStoreSelectedFacet[] =
    deepObjectCopy(selectedFacetsFilter)

  if (
    facetsSelecteds
      .filter((facet) => facet.key === item.key)
      .some(
        (facet) =>
          facet.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ===
          item.value
      )
  ) {
    const indexToRemove = facetsSelecteds.findIndex(
      (f) => f.key + f.value === item.key + item.value
    )

    facetsSelecteds.splice(indexToRemove, 1)
    setSelectedFacetsFilter([...facetsSelecteds])

    return
  }

  setSelectedFacetsFilter([...facetsSelecteds, item])
}
